/**
 * TermsPage - 服务条款页。
 * 复用 LegalPage 布局，内容走 i18n legal.terms。
 */
import LegalPage from "./LegalPage";

export default function TermsPage() {
  return <LegalPage i18nKey="legal.terms" />;
}
